import Image from "next/image";

import CourseDetails from "../../data/course-details/courseData.json";
import useCategoryCount from "@/context/useCategoryCount";
import image6 from "../../public/images/home/image6.svg";
import Link from "next/link";

const CategorySix = () => {
  const { categoryCounts } = useCategoryCount(CourseDetails.courseDetails);
  return (
    <>
      {CourseDetails &&
        CourseDetails.courseDetails.slice(0, 8).map((item, innerIndex) => {
          const count = categoryCounts[item.category] || 0;
          return (
            <div className="col-lg-3 col-md-6 col-sm-6 col-12 mobileviewpadding" key={innerIndex}>
              <div
                className="rbt-cat-box rbt-cat-box-1 list-style"
              >
                <div className="inner">
                  <div className="thumbnail">
                    <Image
                      src={item.img}
                      width={300}
                      height={300}
                      priority
                      alt="Icons Images"
                    />
                  </div>
                  <div className="content">
                    <h5 className="title">{item.category}</h5>
                    <div className="read-more-btn">
                      <Link href="/study-courses">
                        <span className="rbt-btn-link">
                          Course{count !== 1 ? "s" : ""}
                          <i className="feather-arrow-right"></i>
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </>
  );
};

export default CategorySix;
